export const INSPIRATION = 'inspiration';
export const RECENT = 'recent';
export const DASHBOARD = 'dashboard';
